import BasePage from "./BasePage";
import KnockOut from "knockout";

import BookingRegistrationViewModel from "@TestRideEvent/Scripts/ViewModels/BookingRegistrationViewModel";
import LegacyFormHelper from "@Scripts/Infrastructure/LegacyFormHelper";

export default class BookingRegistrationPage extends BasePage {
    private static isProfiling: boolean = false;
    private static isMarketing: boolean = false;
    private static marketingChannels: any[] = [];

    public static async init() {
        await super.init();

        KnockOut.applyBindings(new BookingRegistrationViewModel(), document.getElementById("Page"));

        this.setForm();
        this.setDemoProductBox();
        this.setPersonalDataBox();
        this.getAntiForgeryToken();

        let self = this;

        document.addEventListener("privacy", function (event: any) {
            switch (event.detail?.type) {
                case "profiling":
                    self.isProfiling = event.detail.isProfiling;
                    break;
                case "marketing":
                    self.isMarketing = event.detail.isMarketing;
                    break;
                case "marketingChannels":
                    self.marketingChannels = event.detail.marketingChannels;
                    break;
            }
        });
    }

    private static setForm() {
        let vm = this;
        
        var $form = $("#FormTestRide"),
            $successBox = $(".success-box"),
            $formIntro = $(".form-introduction"),
            $disableOnSubmit = $(".disable-on-submit", $form);

        (<any>$form).ajaxForm({
            iframe: false,
            dataType: "json",
            beforeSubmit: function (formData, jqForm, options) {
                $disableOnSubmit.attr("disabled", "disabled");
                LegacyFormHelper.resetValidation($form);

                this.headers = { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() };

                if (formData.findIndex(x => x.name === "IsProfiling") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsProfiling"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketing") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketing"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingEmail") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingEmail"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingPhone") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingPhone"), 1);
                }
                if (formData.findIndex(x => x.name === "IsMarketingMail") !== -1) {
                    formData.splice(formData.findIndex(x => x.name === "IsMarketingMail"), 1);
                }

                formData.push({ name: "IsProfiling", value: vm.isProfiling, type: "checkbox", required: false });
                formData.push({ name: "IsMarketing", value: vm.isMarketing, type: "checkbox", required: false });
                formData.push({ name: "MarketingChannels", value: vm.marketingChannels, type: "checkbox", required: false });
            },
            success: function (data) {
                LegacyFormHelper.resetValidation($form);

                if (data.eventIdMaster) {
                    (<any>$form).hide();
                    $formIntro.hide();
                    $successBox.show();
                } else {
                    $disableOnSubmit.removeAttr("disabled");
                    LegacyFormHelper.setValidation($form, data.state);
                }
            },
            error: function (xhr, textStatus, errorThrown) {
                LegacyFormHelper.enableControls($form);
                LegacyFormHelper.setValidation($form, xhr.responseJSON);
                (<any>window).grecaptcha.reset();
            }
        });
    }

    private static setDemoProductBox() {
        var $form = $("#FormTestRide");

        $("#DemoProductFrame", $form).on("change", function () {
            if ($("#DemoProductFrame", $form).val()) {
                $(".product-description-intro").hide();
                $(".product-description").hide();
                $(".product-description[data-product='" + $("#DemoProductFrame", $form).val() + "']").show();
            } else {
                $(".product-description-intro").show();
                $(".product-description").hide();
            }
        });
    }

    private static setPersonalDataBox() {
        var $form = $("#FormTestRide");

        setBirthLocation();

        $("#BirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#ButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#BirthCountry", $form).val() === "ITALIA") {
                $("#BirthLocationRow", $form).show();
            } else {
                $("#BirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#Name", $form).val(),
                $surname = $("#Surname", $form).val(),
                $birthDate = $("#BirthDate", $form).val(),
                $birthLocation = $("#BirthLocation", $form).val(),
                $birthCountry = $("#BirthCountry", $form).val(),
                $gender = $("input[name=Gender]:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getTaxCode", {
                name: $name,
                surname: $surname,
                birthDate: $birthDate,
                birthLocation: $birthLocation,
                birthCountry: $birthCountry,
                gender: $gender,
                __RequestVerificationToken: BookingRegistrationPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.data) {
                    LegacyFormHelper.resetValidation($form);
                    $("#TaxCode", $form).val(data.data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data.status);
                }
            });
        }
    }

    public static setParentPersonalDataBox() {
        var $form = $("#FormTestRide");

        setBirthLocation();

        $("#ParentBirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#ParentButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#ParentBirthCountry", $form).val() === "ITALIA") {
                $("#ParentBirthLocationRow", $form).show();
            } else {
                $("#ParentBirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#ParentName", $form).val(),
                $surname = $("#ParentSurname", $form).val(),
                $birthDate = $("#ParentBirthDate", $form).val(),
                $birthLocation = $("#ParentBirthLocation", $form).val(),
                $birthCountry = $("#ParentBirthCountry", $form).val(),
                $gender = $("input[name=ParentGender]:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getParentTaxCode", {
                parentname: $name,
                parentsurname: $surname,
                parentbirthDate: $birthDate,
                parentbirthLocation: $birthLocation,
                parentbirthCountry: $birthCountry,
                parentgender: $gender,
                __RequestVerificationToken: BookingRegistrationPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.data) {
                    LegacyFormHelper.resetValidation($form);
                    $("#ParentTaxCode", $form).val(data.data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data);
                }
            });
        }
    }

    public static setParent2PersonalDataBox() {
        var $form = $("#FormTestRide");

        setBirthLocation();

        $("#Parent2BirthCountry", $form).on("change", function () { setBirthLocation(); });
        $("#Parent2ButtonTaxCode", $form).on("click tap touchstart", function () { calculateTaxCode(); });

        function setBirthLocation() {
            if ($("#Parent2BirthCountry", $form).val() === "ITALIA") {
                $("#Parent2BirthLocationRow", $form).show();
            } else {
                $("#Parent2BirthLocationRow", $form).hide();
            }
        }

        function calculateTaxCode() {
            var $name = $("#Parent2Name", $form).val(),
                $surname = $("#Parent2Surname", $form).val(),
                $birthDate = $("#Parent2BirthDate", $form).val(),
                $birthLocation = $("#Parent2BirthLocation", $form).val(),
                $birthCountry = $("#Parent2BirthCountry", $form).val(),
                $gender = $("input[name=Parent2Gender]:checked", $form).val();

            (<any>window).App.instances.vm.$store.dispatch("profileStore/getParent2TaxCode", {
                parent2name: $name,
                parent2surname: $surname,
                parent2birthDate: $birthDate,
                parent2birthLocation: $birthLocation,
                parent2birthCountry: $birthCountry,
                parent2gender: $gender,
                __RequestVerificationToken: BookingRegistrationPage.getAntiForgeryToken()
            }).then((data) => {
                if (data.data) {
                    LegacyFormHelper.resetValidation($form);
                    $("#Parent2TaxCode", $form).val(data.data.taxCode);
                } else {
                    LegacyFormHelper.setValidation($form, data);
                }
            });
        }
    }

    private static getAntiForgeryToken() {
        var $context = $("#Page");
        return $("input[name=__RequestVerificationToken]", $context).val();
    }
};